import { BlogType } from "src/shared/config";
import { generateId } from "src/shared/utils";

export const newBlogMock: BlogType = {
  id: generateId(),
  title: "",
  date: "",
  description: "",
  image: null,
  imagePath: "",
  tags: [],
};

export const initialState: {
  isLoading: boolean;
  error: string;
  blogs: BlogType[];
  activeBlogId: BlogType["id"];
  newBlog: BlogType;
} = {
  isLoading: false,
  error: "",
  blogs: [],
  activeBlogId: "",
  newBlog: newBlogMock,
};
